<template>
  <div class="auditionWarrp">
    <ul
      class="auditionContent"
      v-for="(item, index) in auditionWarrp.videoInfoRespVOS"
      :key="index"
      @click="auditionClick(item)"
    >
      <li>
        <p>试听</p>
        <span>{{ item.name }}</span>
      </li>
      <li><img
          src="@/assets/img/productDetail/listen.png"
          alt=""
        /></li>
    </ul>
    <DialogComponent
      ref="dialogComponent"
      dialogType="downloadApp"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import DialogComponent from '../../../components/dialogComponent/dialogComponent.vue';

export default {
  components: { DialogComponent },
  computed: {
    ...mapState(['courseBaseData']),
  },
  data() {
    return {
    };
  },
  props: {
    auditionWarrp: {
      type: Object,
      default: () => { },
    },
  },
  watch: {},
  created() { },
  mounted() { },
  destroyed() { },
  methods: {
    auditionClick(item) {
      const schedule = this.auditionWarrp.curriculumRespVO.id;
      const coursesId = item.id;
      const videoName = item.name;
      if (this.$root.$data.isApp) {
        // App交互
        this.$sendToApp(
          'goTrialCoursePage',
          {
            courseId: this.courseBaseData.productId,
            productCurriculumId: schedule,
            videoId: coursesId,
            videoName,
            courseName: this.courseBaseData.name,
          },
          false,
        );
      } else {
        this.$router.push({
          path: '/audition',
          query: {
            coursesId,
            containCurriculumId: schedule,
          },
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.auditionWarrp {
  width: 100%;
  overflow: hidden;
  .auditionContent {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    margin: 0 36px;
    padding: 43px 0;
    border-bottom: 1.1px solid #f5f5f5;
    li {
      font-size: 0;
      &:nth-of-type(1) {
        p {
          display: inline-block;
          box-sizing: border-box;
          max-width: 6.9rem;
          margin-right: 18px;
          padding: 2px 18px;
          color: $theme_color;
          font-size: 22px;
          line-height: 28px;
          border: 1.1px solid;
          border-color: $theme_color;
          border-radius: 4px;
        }
        span {
          color: #808080;
          font-weight: 400;
          font-size: 25px;
          line-height: 40px;
        }
      }
      &:nth-of-type(2) {
        display: flex;
        align-items: center;
        img {
          width: 22px;
          height: 22px;
        }
      }
    }
  }
}
</style>
